import React from 'react';

import { ANTI_AGING, INGREDIENTS } from './ingredients-info';
import type { IngredientsProps } from '../Ingredients';

export const INGREDIENTS_ANTI_AGING_CONTENT: IngredientsProps = {
  header: (
    <React.Fragment>
      Custom ingredients,
      <br /> mixed for you
    </React.Fragment>
  ),
  ingredients: INGREDIENTS[ANTI_AGING],
};
